import React from "react";
import { motion } from "framer-motion";
import { Loader2 } from "lucide-react";

interface LoadingProps {
	size?: "sm" | "md" | "lg" | "full";
	text?: string;
	className?: string;
}

const Loading: React.FC<LoadingProps> = ({
	size = "md",
	text,
	className = "",
}) => {
	const sizeClasses = {
		sm: "h-4 w-4",
		md: "h-8 w-8",
		lg: "h-12 w-12",
		full: "h-16 w-16",
	};

	const textSizeClasses = {
		sm: "text-sm",
		md: "text-base",
		lg: "text-lg",
		full: "text-xl",
	};

	return (
		<motion.div
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			className={`flex flex-col items-center justify-center space-y-3 ${className} ${size === "full" ? "h-screen" : ""}`}
		>
			<Loader2
				className={`${sizeClasses[size]} animate-spin text-primary-500`}
			/>
			{text && (
				<p className={`${textSizeClasses[size]} text-gray-600 font-medium`}>
					{text}
				</p>
			)}
		</motion.div>
	);
};

export default Loading;
